export const validatePassword = (password, confirmPassword = "") => {
  const isLengthValid = password.length >= 8;
  const hasNumber = /\d/.test(password);
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasSpecialChar = /[!@#$%^&*]/.test(password);
  const confirmPasswordValid = password === confirmPassword;

  return {
    isLengthValid,
    hasNumber,
    hasUpperCase,
    hasLowerCase,
    hasSpecialChar,
    confirmPasswordValid,
  };
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);

  // Add 5 hours 30 minutes (19800000 ms)
  const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);

  const day = istDate.getDate();
  const month = istDate.getMonth() + 1;
  const year = istDate.getFullYear();

  let hours = istDate.getHours();
  const minutes = istDate.getMinutes().toString().padStart(2, '0');
  const seconds = istDate.getSeconds().toString().padStart(2, '0');

  const period = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const paddedHours = hours.toString().padStart(2, '0');

  return `${day}/${month}/${year}, ${paddedHours}:${minutes}:${seconds} ${period}`;
};


export const calculateApplicationStatusMetrics = (applications) => {
  const total = applications?.length;

  const statusCounts = {
    onTrack: 0,
    atRisk: 0,
    overdue: 0,
    approved: 0,
    rejected: 0,
    pending: 0,
    clarification: 0
  };

  applications?.forEach((app) => {
    // Normalize SLA status
    const sla = app.sla_status?.toLowerCase();
    if (sla === "on track") statusCounts.onTrack++;
    else if (sla === "at risk") statusCounts.atRisk++;
    else if (sla === "overdue") statusCounts.overdue++;

    // Normalize general status
    const generalStatus = app.status?.toLowerCase();
    if (generalStatus.includes("approved")) {
      statusCounts.approved++;
    } else if (generalStatus.includes("rejected")) {
      statusCounts.rejected++;
    } else if (generalStatus.includes("progress")) {
      statusCounts.pending++;
    } else if (generalStatus.includes("clarification")) {
      statusCounts.pending++;
    }
  });

  const slaCompliance = total === 0 ? 0 : ((statusCounts.onTrack / total) * 100).toFixed(1);

  return {
    slaCompliance: slaCompliance,
    statusCounts,
    total,
  };
}

export const validateAadhaar = (aadhaar) => {
  const aadhaarRegex = /^([2-9]\d{11}|[2-9]\d{3} \d{4} \d{4})$/;
  if (!aadhaarRegex.test(aadhaar)) return false;
  if (aadhaar.replace(/\s/g, '') === '000000000000') return false;
  return true;
};
//export const validateAadhaar = (aadhaar) => {
//  const aadhaarRegex = /^[2-9]{1}[0-9]{11}$/;
//  return aadhaarRegex.test(aadhaar);
//};
export const validatePhoneNumber = (phoneNumber) => {
  const phoneRegex = /^[6789]\d{9}$/;
  return phoneRegex.test(phoneNumber);
};
export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
export const validatePincode = (pincode) => {
  const pincodeRegex = /^[1-9][0-9]{5}$/;
  return pincodeRegex.test(pincode);
};
export const validateName = (name) => {
  const nameRegex = /^[a-zA-Z\s]+$/;
  return nameRegex.test(name);
};
export const validateLandRecord = (landRecord) => {
  const landRecordRegex = /^[a-zA-Z0-9\s]+$/;
  return landRecordRegex.test(landRecord);
};
export const validateSurveyNumber = (surveyNumber) => {
  const surveyNumberRegex = /^[a-zA-Z0-9\s]+$/;
  return surveyNumberRegex.test(surveyNumber);
};
